// klm-client-frontend/src/store/slices/maintenanceSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as maintenanceApi from '../api/maintenance';

// Async thunks
export const checkMaintenanceStatus = createAsyncThunk(
  'maintenance/checkStatus',
  async (_, { rejectWithValue }) => {
    try {
      const response = await maintenanceApi.getMaintenanceStatus();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to check maintenance status');
    }
  }
);

// Initial state
const initialState = {
  isActive: false,
  title: '',
  message: '',
  estimatedDuration: 0,
  startedAt: null,
  reason: '',
  affectedServices: [],
  loading: false,
  error: null,
  lastChecked: null
};

// Slice
const maintenanceSlice = createSlice({
  name: 'maintenance',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetMaintenanceState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkMaintenanceStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkMaintenanceStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.isActive = action.payload.data.isActive;
        state.title = action.payload.data.title || '';
        state.message = action.payload.data.message || '';
        state.estimatedDuration = action.payload.data.estimatedDuration || 0;
        state.startedAt = action.payload.data.startedAt || null;
        state.reason = action.payload.data.reason || '';
        state.affectedServices = action.payload.data.affectedServices || [];
        state.lastChecked = new Date().toISOString();
      })
      .addCase(checkMaintenanceStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to check maintenance status';
        state.lastChecked = new Date().toISOString();
      });
  }
});

export const { clearError, resetMaintenanceState } = maintenanceSlice.actions;

// Selectors
export const selectMaintenance = (state) => state.maintenance;
export const selectIsMaintenanceActive = (state) => state.maintenance.isActive;
export const selectMaintenanceLoading = (state) => state.maintenance.loading;

export default maintenanceSlice.reducer;